<template>
<div>
    <!-- Modal -->
    <div class="modal fade" :id="'editarDatosConsumoAT3'+index" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel"> Edición Datos de Consumo: {{nombre }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <table class="table table-hover table-sm table-striped tamano">
                        <thead>
                            <tr>
                                <th>Mes</th>
                                <th>kWh</th>
                                <th>$FijoMes</th>
                                <th>$Energía</th>
                                <th>$Serv/Pub</th>
                                <th>$Transporte</th>
                                <th>Cargo por demanda máxima de potencia leída</th>
                                <th>Total</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(data, index) in boleta" :key="index" class="text-right">
                                <td>{{data.mes}} </td>
                                <td><input v-model.number="kwconsumo[index]" size="5" class="text-right"></td>
                                <td><input v-model.number="cfijo[index]" size="5" class="text-right"></td>
                                <td><input v-model.number="clpe[index]" size="5" class="text-right"></td>
                                <td><input v-model.number="cspb[index]" size="5" class="text-right"></td>
                                <td><input v-model.number="clpt[index]" size="5" class="text-right"></td>
                                <td><input v-model.number="cT13[index]" size="5" class="text-right"></td>
                                <td>{{cfijo[index]+clpe[index]+cspb[index]+clpt[index]+cT13[index] | formato}} </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal" data-placement="top" title="Cerrar"><i class="far fa-times-circle"></i></button>
                    <button type="button" class="btn btn-info" data-dismiss="modal" data-placement="top" title="Guardar" @click.prevent="guardarConsumo"><i class="far fa-save"></i></button>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
export default {
    name: 'ModalEditarConsumoAT3',
    props: [
        'index'
    ],
    data() {
        return {
            idDoc: '',
            nombre: '',
            tarifa: '',
            boleta: [],
            kwconsumo: [],
            totalkwc: 0,
            clpe: [], // cargo por energía  
            totalclpe: 0,
            clpt: [], // cargo por transporte
            totalclpt: 0,
            cfijo: [], // cargo fijo
            totalcfijo: 0,
            cspb: [], // cargo servicio publico
            totalcspb: 0,
            cT13: [], //Cargo por demanda máxima de potencia leída
            totalcT13: 0,
            totaltotal: 0,
            totalcolumna: [],
            miboleta: [],
            boletaauxiliar: []
        }
    },
    created() {
        this.nombre = this.$store.getters.enviarDataClientes[this.index].nombre;
        this.tarifa = this.$store.getters.enviarDataClientes[this.index].tarifa;
        this.idDoc = this.$store.getters.enviarDataClientes[this.index].idDoc;
        this.boleta = this.$store.getters.enviarDataClientes[this.index].boleta;
        for (let ii = 0; ii < 12; ii++) {
            this.kwconsumo[ii] = this.boleta[ii].kwconsumo;
            this.clpe[ii] = this.boleta[ii].cargoTarifario_04;
            this.clpt[ii] = this.boleta[ii].cargoTarifario_02;
            this.cfijo[ii] = this.boleta[ii].cargoTarifario_01;
            this.cspb[ii] = this.boleta[ii].cargoTarifario_03;
            this.cT13[ii] = this.boleta[ii].cargoTarifario_13;
        }

    },
    methods: {
        guardarConsumo() {

            for (let ii = 0; ii < 12; ii++) {
                this.boletaauxiliar = {
                    mes: this.boleta[ii].mes,
                    kwconsumo: (this.kwconsumo[ii]),
                    cargoTarifario_01: (this.cfijo[ii]),
                    cargoTarifario_02: (this.clpt[ii]),
                    cargoTarifario_03: (this.cspb[ii]),
                    cargoTarifario_04: (this.clpe[ii]),
                    cargoTarifario_13: (this.cT13[ii]),
                }
                this.miboleta.push(this.boletaauxiliar)
            }

            this.boleta = {
                idDoc: this.idDoc,
                datos: this.miboleta
            }
            //console.log(this.miboleta);
            this.$store.dispatch('editarDatosConsumo', this.boleta)

        }
    }
}
</script>

<style>

</style>
